import {Injectable} from '@angular/core';

/**
 * Translations for contact management.
 */
@Injectable()
export class ContactManagementTranslationsService {
  public i18nSuccessAddContact: any = $localize`:@@alertService.alert.success.addContactCreate:Contact was added successfully!`;
  public i18nSuccessUpdateContact: any = $localize`:@@alertService.alert.success.addContactUpdate:Contact was updated successfully!`;

  public i18nErrorAddContact: any = $localize`:@@alertService.alert.error.addContactCreate:Error occurred. Contact could not be saved.`;
  public i18nErrorUpdateContact: any = $localize`:@@alertService.alert.error.addContactUpdate:Error occurred. Contact could not be updated.`;
  public i18nErrorFetchingContacts: any = $localize`:@@alertService.alert.error.fetchingContacts:Error occurred. Contact could not fetch contacts.`;

  constructor() { }
}
